import { useMutation } from '@tanstack/react-query';
import type { PayloadLocale } from '@fluenceur/types';
import api from '@/libs/axiosInstance';
import type { InvitationMethod } from '@/types/invitation';
import { trackProductAction } from '@/libs/product-analytics';

type Input = {
  invitationId: string;
  channel: InvitationMethod;
  message?: string; // Legacy support
  messageSnapshot?: string; // Lexical JSON editor state
  messageLanguage?: PayloadLocale; // Optional locale override (email channel only)
  recommendationId?: string;
  // Brand template attribution. Null/absent for system defaults; the backend
  // guards brand ownership before persisting.
  templateId?: string | null;
};

type Response = {
  success: boolean;
  message?: string;
};

const sendInvitationFn = async (params: Input): Promise<Response> => {
  const response = await api.post(`/dashboard/invitations/${params.invitationId}/send`, {
    channel: params.channel,
    message: params.message,
    messageSnapshot: params.messageSnapshot,
    ...(params.messageLanguage ? { messageLanguage: params.messageLanguage } : {}),
    ...(params.recommendationId ? { recommendationId: params.recommendationId } : {}),
    ...(params.templateId ? { templateId: params.templateId } : {}),
  });
  return response.data;
};

export const useSendInvitation = () => {
  return useMutation<Response, Error, Input>({
    mutationFn: (params) =>
      trackProductAction('invitations', 'send', () => sendInvitationFn(params)),
  });
};
